import logo from '../img/logo-softmining.svg';
import info from '../img/InfoIcon.png';
import '../css/Home.css';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="Home">
      <Link to="/">
        <img src={info} className="infoIcon" alt="Documantation" />
      </Link>
      <header className="Home-header">
        <img src={logo} className="Home-logo" alt="logo" />
        <h1 className="titolo TitoloHome">SOFTMINING</h1>
        <p>
              <Link className="Home-button button"  to="/login">Sign in</Link>
              <span className="subtitle text">
                      &nbsp;&nbsp;&nbsp;or&nbsp;&nbsp;&nbsp;
              </span>
              <Link className="Home-button button" to="/signup">Sign up</Link>
        </p>
      </header>
    </div>
  );
}

export default Home;
